"use strict";
export default function main() {
  const $tab = $("#m_tab_cat");
  const $tabContents = $("#m_tab_cat_contents");
  $(function () {
    /**
     * tabクリック時の挙動
     */
    $tab.find("li").on("click", function () {
      // current classの付け替え
      $tab.find("li").removeClass("__current");
      $(this).addClass("__current");

      //targetの取得とclassの付け替え
      let target = $(this).attr("data-target");
      $tabContents.find(".parts_article_lists").removeClass("active");
      $(target).addClass("active");

      // 高さの設定
      setTabContentsHeight();
    });
    /**------------------読み込み時の高さの設定 */
    setTabContentsHeight();
    $(window).on("load", function () {
      setTabContentsHeight();
    });
    /**------------------resize時の高さの設定 */
    let lastInnerWidth = $(window).innerWidth();
    $(window).on("resize", function () {
      // 現在と前回の横幅が違う場合だけ実行
      if (lastInnerWidth != $(window).innerWidth()) {
        // 横幅を記録しておく
        lastInnerWidth = window.innerWidth;
        setTabContentsHeight();
      }
    });
    function setTabContentsHeight() {
      let tabContentsHeight = $tabContents.find(".active").innerHeight();
      console.log(tabContentsHeight);
      $tabContents.height(tabContentsHeight);
    }
  });
}
